export enum JobStatus {
  ToDo,
  InProgress,
  Done,
  OnHold,
}
